import React from 'react';
import Link from 'next/link';
import cn from 'classnames';
import styles from './DropdownItem.module.css';

const DropdownItem = ({ href, icon, title, text, colors, itemType, navResponsive }) => (
  <li className={cn(styles.dropdownItem, 'm-0 p-0 select-none lg:whitespace-nowrap')}>
    <Link href={href}>
      <a>
        <div className="flex items-center font-normal transition-colors duration-300 ease group">
          <span
            className={cn(
              'w-4 h-4 mr-1.5 md:mr-4 block transform transition-transform duration-300 ease group-hover:scale-110 flex-shrink-0',
              itemType === 'big' ? 'lg:h-12 lg:w-12' : 'lg:h-10 lg:w-10',
              { [`${colors.icon} rounded-full`]: itemType !== 'big' }
            )}
          >
            {icon}
          </span>
          <p>
            <span className={`block whitespace-nowrap text-xs md:text-sm ${colors.title}`}>
              {title}
            </span>
            {text && !navResponsive && (
              <span className={`block text-sm ${colors.text} mt-1.5`}>{text}</span>
            )}
          </p>
        </div>
      </a>
    </Link>
  </li>
);

DropdownItem.defaultProps = {
  text: null,
  itemType: ''
};

export default DropdownItem;
